import { apiClient } from './apiClient'

export interface CategoryResponse {
  id: string
  name: string
  color: string
  icon: string | null
  parentId: string | null
  depth: number
  /** Ordre d'affichage parmi les catégories de même parent (écran W37). */
  position: number
}

export interface CreateCategoryRequest {
  name: string
  color: string
  icon?: string
  parentId?: string
}

/** Remplacement complet : `parentId` absent = catégorie principale. */
export interface UpdateCategoryRequest {
  name: string
  color: string
  icon?: string
  parentId?: string | null
}

/** Client typé du module product_catalog/categories — cf. boutiklic-core CategoryController (écrans C4, W37). */
export const categoriesApi = {
  getAll: () => apiClient.get<CategoryResponse[]>('/categories'),
  create: (payload: CreateCategoryRequest) => apiClient.post<CategoryResponse>('/categories', payload),
  update: (categoryId: string, payload: UpdateCategoryRequest) =>
    apiClient.put<CategoryResponse>(`/categories/${categoryId}`, payload),
  /** Les articles repassent « Non classés », les sous-catégories remontent d'un niveau. */
  remove: (categoryId: string) => apiClient.delete<void>(`/categories/${categoryId}`),
  /** Ordre COMPLET des catégories d'un même parent (`parentId` null = catégories principales). */
  reorder: (parentId: string | null, orderedIds: string[]) => apiClient.put<void>('/categories/reorder', { parentId, orderedIds }),
}
